
define('ldsh!modules/start/dashboard/qualify/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="panel panel-default right-panel">\n    <div class="panel-heading center">\n        <span id="closePopover" class="i18n panel-title" data-i18n="PUBLIC.PRODUCTS.DASHBOARD.TITLES.QUALIFICATION">Cualificación</span>&nbsp;\n        <span id="qualificationHelp" class="helpTextIcon cursorHand" data-original-title="" title="">\n            <font class="helpTextContent">?</font>\n        </span>\n    </div>\n    <div class="panel-body">\n        <div id="venn-chart" class="pull-center" style="padding-top: 16px"></div>\n    </div>\n</div>\n';

}
return __p
};});

